export default __webpack_public_path__ + "static/media/heroBannerKO.78f9ff15.png";